import { useEffect } from "react";

// Kaydedilmemiş form değişikliği varken sekmeyi kapatma/yenileme uyarısı.
const useUnsavedChanges = (dirty) => {
  useEffect(() => {
    if (!dirty) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [dirty]);
};

export default useUnsavedChanges;
